module.exports = __webpack_public_path__ + "img/logo-netsuite.d7b9cadb.png";